/* eslint-disable react/no-unstable-nested-components */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Col, ModalProps, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import Dialog from "../../components/Dialog";
import {
    ExpandLessRegularIcon,
    ExpandMoreRegularIcon,
    IconCalendar,
    InformationIcon,
    UserIcon,
} from "../../components/Icons";
import ActivityPlanService from "../../service/Docente/ActivityPlanService";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import {
    StyledCardWhite,
    StyledExpandContainer,
    StyledExpandLabel,
    StyledExpandTextInfo,
    StyledIconInfo,
    StyledSubtitle,
    StyledTableExpand,
} from "../../styles/pages/AcademicActivityPlan/ModalDetailsAcademicActivityStyles";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const { BtnPrimary } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton } = DialogStyles;

export interface IModalDetailsAcademicActivityProps extends ModalProps {
    teachingActivityPlanId: number;
}

function ModalDetailsAcademicActivity(
    props: IModalDetailsAcademicActivityProps
) {
    const { instance } = useMsal();

    const [activityPlan, setAcctivityPlan] = useState<any>({});
    const [activityPlanItems, setActivityPlanItems] = useState(
        new Array<any>()
    );

    const clearComponent = () => {
        setAcctivityPlan({});
        setActivityPlanItems(new Array<any>());
    };

    const handleClose = () => {
        clearComponent();
        props?.onClose();
    };

    const getTeachingActivityPlan = async () => {
        const response = await ActivityPlanService.getTeachingActivityPlan(
            props.teachingActivityPlanId,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setAcctivityPlan(response.data);
            setActivityPlanItems(
                response.data?.planoAtividadeDocenteItems?.map((item: any) => {
                    return {
                        planoAtividadeDocenteItemId:
                            item.planoAtividadeDocenteItemId,
                        descricaoAtividade: item.atividade.descricaoAtividade,
                        tipoHora: item.tipoHora.tipoHoraDescricao,
                        cargaHoraria: Number(item.cargaHoraria)?.toFixed(1),
                        escolaCurso: item.abrangencia.nome,
                        estudante:
                            item.atividade.temEstudante === "S" ? "Sim" : "Não",
                        detalhamento: item.atividadeDetalhamento,
                        estudantes: item.estudantes.map((estudante: any) => {
                            return {
                                estudanteId: estudante.estudanteId,
                                cpfPassaporte:
                                    estudante.cpf || estudante.passaporte,
                                nome: estudante.nome,
                                ativo: estudante.ativo,
                            };
                        }),
                    };
                })
            );
        }
    };

    useEffect(() => {
        getTeachingActivityPlan();
    }, []);

    const columns = [
        {
            dataField: "descricaoAtividade",
            text: "Atividade",
        },
        {
            dataField: "tipoHora",
            text: "Tipo de hora",
            style: { width: 125 },
        },
        {
            dataField: "cargaHoraria",
            text: "Hora/aula",
        },
        {
            dataField: "escolaCurso",
            text: "Escola/Curso",
        },
        {
            dataField: "estudante",
            text: "Estudante",
        },
    ];

    const expandRow = {
        renderer: (plan: any) => (
            <StyledExpandContainer>
                {plan.estudantes && (
                    <Row>
                        {plan.estudantes.map(
                            (item: any, index: number) =>
                                item.ativo && (
                                    <Col
                                        xs="6"
                                        className="mb-4"
                                        style={{
                                            borderRight:
                                                index % 2 === 0
                                                    ? "1px solid #E4E4E4"
                                                    : "",
                                        }}
                                    >
                                        <Row xs="12">
                                            <Col xs="6">
                                                <StyledExpandLabel>
                                                    CPF/Passaporte
                                                </StyledExpandLabel>
                                                <StyledExpandTextInfo>
                                                    {item?.cpfPassaporte}
                                                </StyledExpandTextInfo>
                                            </Col>
                                            <Col xs="6">
                                                <StyledExpandLabel>
                                                    Estudante
                                                </StyledExpandLabel>
                                                <StyledExpandTextInfo>
                                                    {item?.nome}
                                                </StyledExpandTextInfo>
                                            </Col>
                                        </Row>
                                    </Col>
                                )
                        )}
                    </Row>
                )}
                <Row>
                    <Col xs="12">
                        <StyledExpandLabel>Detalhamento</StyledExpandLabel>
                        <StyledExpandTextInfo>
                            {plan?.detalhamento}
                        </StyledExpandTextInfo>
                    </Col>
                </Row>
            </StyledExpandContainer>
        ),
        expandHeaderColumnRenderer: () => {
            return <b>Detalhes</b>;
        },
        expandColumnRenderer: ({ expanded }: any) => {
            if (expanded)
                return <ExpandLessRegularIcon style={{ fill: "#404040" }} />;
            return <ExpandMoreRegularIcon style={{ fill: "#404040" }} />;
        },
        expandByColumnOnly: true,
        expandColumnPosition: "right",
        showExpandColumn: true,
    };

    return (
        <Dialog openModal={props.open} onHide={handleClose} size="width-1000">
            <StyledModalTitle style={{ marginBottom: "0" }}>
                {`TACH - ${activityPlan.vigenciaPlanoAtividade?.semestre}º semestre ${activityPlan.vigenciaPlanoAtividade?.ano}`}
            </StyledModalTitle>
            <StyledSubtitle>
                <StyledIconInfo>
                    <UserIcon />
                    <span>{`Professor ${activityPlan.professor?.nome}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>{`Matrícula: ${activityPlan.professor?.matriculaAdp}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <IconCalendar />
                    <span>{`Vigência: ${StringUtils.formatDateString(
                        activityPlan.dataVigenciaInicio
                    )} até ${StringUtils.formatDateString(
                        activityPlan.dataVigenciaFim
                    )}`}</span>
                </StyledIconInfo>
            </StyledSubtitle>
            <StyledCardWhite body>
                <StyledTableExpand>
                    <BootstrapTable
                        keyField="planoAtividadeDocenteItemId"
                        data={activityPlanItems}
                        columns={columns}
                        expandRow={expandRow as any}
                        striped
                    />
                </StyledTableExpand>
            </StyledCardWhite>
            <StyledContainerButton>
                <BtnPrimary onClick={handleClose}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );
}

export default ModalDetailsAcademicActivity;
